import { FabProps } from '@material-ui/core';
import { ChevronRight } from '@material-ui/icons';
import React from 'react';
import { SpaceProps, WidthProps, space, width } from 'styled-system';
import { styled } from '~ui-kit/styled-components';
import { FloatingdButton } from '../floatingd-button';

export interface CTAButtonProps extends FabProps, SpaceProps, WidthProps {
  children: React.ReactNode;
  isLoading?: boolean;
  withChevron?: boolean;
  type?: 'button' | 'submit';
}

export function CTAButton({ children, type = 'button', withChevron = true, isLoading, ...props }: CTAButtonProps) {
  return (
    <StyledButton {...props} color="primary" size="large" type={type} isLoading={isLoading}>
      {children}
      {withChevron && <ChevronRight />}
    </StyledButton>
  );
}

const StyledButton = styled(FloatingdButton)`
  && {
    ${space};
    ${width};
    min-width: 112px;
    padding-top: 8px;
    padding-right: 24px;
    padding-bottom: 8px;
    padding-left: 24px;
    min-height: 40px;
  }
`;
